import { useNavigate } from "react-router-dom";
import { ForgotPasswordForm as UIForgotPasswordForm } from "@racoon/ui";
import { AuthResponse } from "@racoon/api";
import { useSendOtpMutation, useResetPasswordMutation } from "~/shared/api/auth/auth.api";

export const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const sendResetOtpMutation = useSendOtpMutation();
  const resetPasswordMutation = useResetPasswordMutation();

  const handleSuccess = (_data: AuthResponse) => {
    navigate("/dashboard");
  };

  return (
    <UIForgotPasswordForm
      sendOtpMutation={sendResetOtpMutation}
      resetPasswordMutation={resetPasswordMutation}
      onSuccess={handleSuccess}
      onNavigateToLogin={() => navigate("/login")}
      onNavigateToSmsLogin={() => navigate("/login?method=sms")}
      isGrpc={true}
    />
  );
};
